import React, { useMemo } from 'react'

import usePresenceSub from 'hooks/usePresenceSubscription'
import { ActivityGroupByAccountAndEndUsersBody, Insight } from 'modules/accountActivity/domain'
import CardHeader from 'sections/CCRM/FeedCard/CardHeader'

import ActivityContent from './ActivityContent'

import styles from './styles.module.css'

const RECENT_ACTIVITY_THRESHOLD_MS = 60 * 60 * 1000 // 1 hour

interface WebActivityCardProps {
  insight: Insight
}

const WebActivityCard: React.FC<WebActivityCardProps> = ({ insight }) => {
  const { companyData } = insight
  const body = insight.body as ActivityGroupByAccountAndEndUsersBody
  const contactList = body.activityGroupsByEndUser
    .map(group => group.endUserData)
    .filter(group => !!group)

  const recentlyActive = useMemo(() => {
    return body.activityGroupsByEndUser
      .filter(group => group.lastActivityAt > Date.now() - RECENT_ACTIVITY_THRESHOLD_MS)
      .map(group => group.endUserData)
  }, [body.activityGroupsByEndUser])
  const presentEndUserIds = usePresenceSub(insight.orgId, recentlyActive)

  return (
    <>
      <div>
        <CardHeader
          insight={insight}
          visitorList={contactList}
        />
      </div>
      <div className={styles.expandedActivities}>
        <ActivityContent
          insight={insight}
          activityByEndUser={body.activityGroupsByEndUser}
          maxContactToShow={3}
          companyData={companyData}
          presentEndUserIds={presentEndUserIds}
        />
      </div>
    </>
  )
}

export default WebActivityCard
